module.exports = __webpack_public_path__ + "img/logo.080d31c8.png";